import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  const location = useLocation();
  const pageUrl = `https://sentinelhub.com.br${location.pathname}`;

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>404 — Página não encontrada | SentinelHub</title>
        <meta name="description" content="A página que você procurou não existe. Volte para a home do SentinelHub." />
        <meta name="robots" content="noindex, follow" />
        <meta property="og:title" content="404 — Página não encontrada | SentinelHub" />
        <meta property="og:description" content="A página que você procurou não existe. Volte para a home do SentinelHub." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content="https://sentinelhub.com.br/og-image.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:title" content="404 — Página não encontrada | SentinelHub" />
        <meta name="twitter:description" content="A página que você procurou não existe. Volte para a home do SentinelHub." />
        <meta name="twitter:image" content="https://sentinelhub.com.br/og-image.jpg" />
      </Helmet>
      <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          Return to Home
        </a>
      </div>
    </div>
    </>
  );
};

export default NotFound;
